import React, { useEffect, useState, useRef } from "react";
import "../../styles/components/ScrollableChipComponent.scss";
import CloseIcon from "../../images/closeIcon.svg";
import LeftArrow from "../../images/scrollLeftIcon.svg";
import RightArrow from "../../images/scrollRightIcon.svg";
import PrimaryButtonOutline from "./PrimaryButtonOutline";

const ScrollableChipComponent = ({
  filterDataToDisplay,
  handleReset,
  values,
  setValues,
  setSearchText,
  setnobannerFound,
  noData,
  setGenericInfo,
  genericInfo,
  selectedFilters,
  setSelectedFilters,
  handleResetSync,
}) => {
  const [showRightArrowButton, setShowRightArrowButton] = useState(false);
  const [showLeftArrowButton, setShowLeftArrowButton] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = document.querySelector(".scroll-container");

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;

      setShowLeftArrowButton(scrollLeft > 0);
      setShowRightArrowButton(scrollWidth - clientWidth > scrollLeft + 1);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [filterDataToDisplay]);

  const leftScroll = () => {
    const container = scrollContainerRef.current;
    container.scrollBy({
      left: -100,
      behavior: "smooth",
    });
  };

  const rightScroll = () => {
    const container = scrollContainerRef.current;
    container.scrollBy({
      left: 100,
      behavior: "smooth",
    });
  };

  const isArr = (v) => Array.isArray(v);

  const handleDeleteWithSync = (item) => {
    let updatedValues = { ...values };
    let updatedSelectedFilters = { ...selectedFilters };

    if (
      isArr(values.indication) &&
      values.indication.some(
        (indication) => indication.displayName === item.displayName
      )
    ) {
      updatedValues.indication = values.indication.filter(
        (indication) => indication.displayName !== item.displayName
      );
      updatedSelectedFilters.Indication = (
        updatedSelectedFilters.Indication || []
      ).filter((name) => name !== item.displayName);
    } else if (
      isArr(values.mlrStatus) &&
      values.mlrStatus.some((status) => status.displayName === item.displayName)
    ) {
      updatedValues.mlrStatus = values.mlrStatus.filter(
        (status) => status.displayName !== item.displayName
      );
      updatedSelectedFilters["MLR Status"] = (
        updatedSelectedFilters["MLR Status"] || []
      ).filter((name) => name !== item.displayName);
    } else if (
      isArr(values.brand) &&
      values.brand.some((brand) => brand.displayName === item.displayName)
    ) {
      updatedValues.brand = values.brand.filter(
        (brand) => brand.displayName !== item.displayName
      );
      updatedSelectedFilters.Product = (
        updatedSelectedFilters.Product || []
      ).filter((name) => name !== item.displayName);
    } else if (
      isArr(values.market) &&
      values.market.some((market) => market.displayName === item.displayName)
    ) {
      updatedValues.market = values.market.filter(
        (market) => market.displayName !== item.displayName
      );
      updatedSelectedFilters.Country = (
        updatedSelectedFilters.Country || []
      ).filter((name) => name !== item.displayName);
    } else if (
      item.displayName === "Static" ||
      item.displayName === "Animated"
    ) {
      updatedValues.templateType = [];
      updatedSelectedFilters["Banner Type"] = [];
      setGenericInfo({ ...genericInfo, templateType: [] });
    } else if (
      isArr(values.contentType) &&
      values.contentType.some(
        (contentType) => contentType.displayName === item.displayName
      )
    ) {
      updatedValues.contentType = values.contentType.filter(
        (contentType) => contentType.displayName !== item.displayName
      );
      updatedSelectedFilters["Content Type"] = (
        updatedSelectedFilters["Content Type"] || []
      ).filter((name) => name !== item.displayName);
    } else if (item.metaDataType === "templateNameInput") {
      updatedValues.templateNameInput = "";
      setSearchText("");
    }

    setValues(updatedValues);
    setSelectedFilters(updatedSelectedFilters);
    setnobannerFound(noData);
  };

  const handleResetWithSync = () => {
    if (handleResetSync) {
      handleResetSync();
    } else {
      handleReset();
    }
  };

  return (
    <>
      <div className={`${showLeftArrowButton ? "arrow-navigation" : ""}`}>
        {showLeftArrowButton && (
          <img
            src={LeftArrow}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={leftScroll}
          />
        )}
      </div>

      <div
        className="scroll-container"
        id="scroll-container"
        ref={scrollContainerRef}
      >
        {filterDataToDisplay?.map((item, index) => (
          <div key={index} className="custom-chip">
            <span>{item.displayName}</span>
            <img
              src={CloseIcon}
              alt=""
              className="close-icon"
              onClick={(e) => {
                handleDeleteWithSync(item);
              }}
            />
          </div>
        ))}

        {filterDataToDisplay.length > 0 &&
          !showRightArrowButton &&
          !showLeftArrowButton && (
            <PrimaryButtonOutline
              title={`Reset All`}
              handleClick={handleResetWithSync}
              btnType="outline"
              showIcon={false}
              height={32}
            />
          )}
      </div>

      <div
        className={`${showRightArrowButton ? "arrow-navigation-right" : ""}`}
      >
        {showRightArrowButton && (
          <img
            src={RightArrow}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={rightScroll}
          />
        )}
      </div>

      {(showRightArrowButton || showLeftArrowButton) && (
        <div className="resetl-all">
          <PrimaryButtonOutline
            title={`Reset All`}
            handleClick={handleResetWithSync}
            btnType="outline"
            showIcon={false}
            height={32}
          />
        </div>
      )}
    </>
  );
};

export default ScrollableChipComponent;
